module.exports = __webpack_public_path__ + "static/media/21.5bb15f29.jpg";